import styles from './style.module.css';

export default function Experiment(){
    return(
        <div className={styles['wrap']}>
        </div>
    )
}